import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

interface Props {
  label?: string
  placeholder?: string
  value?: string | number
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  unit?: string
  type?: string
}

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
`

const Label = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`

const LabelLine = styled.div`
  width: 4px;
  height: 100%;
  border-radius: 99px;
  background: #2f3c5e;
`

const LabelName = styled.div`
  font-family: SUIT;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  align-items: flex-start;
`

const Input = styled.input`
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  height: 32px;
  width: 100%;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #b3b3b3;
  }
`

const InputLine = styled.div`
  width: 100%;
`

const InputUnit = styled.div`
  position: absolute;
  right: 0;
`

const Unit = styled.div`
  color: #b3b3b3;
  display: flex;
  align-items: center;
`

const LabelInput = (props: Props) => {
  const { label, placeholder, value, onChange, unit, type } = props

  const [inputValue, setInputValue] = useState<string | number>(value || '')

  useEffect(() => {
    if (type === 'number' && value !== undefined) {
      const val = value.toString()
      const [integer, decimal] = val.split('.')
      const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      setInputValue(
        decimal ? `${formattedInteger}.${decimal}` : formattedInteger
      )
    } else {
      setInputValue(value || '')
    }
  }, [value, type])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value
    if (type === 'number') {
      val = val.replace(/,/g, '') // 기존의 콤마 제거
      if (!isNaN(Number(val))) {
        const [integer, decimal] = val.split('.')
        const formattedInteger = Number(integer).toLocaleString() // 콤마 추가
        const formattedValue =
          decimal !== undefined
            ? `${formattedInteger}.${decimal}`
            : formattedInteger
        setInputValue(formattedValue)
        if (onChange) {
          const event = { ...e, target: { ...e.target, value: val } }
          onChange(event)
        }
        return
      }
    }
    setInputValue(val)
    if (onChange) {
      const event = { ...e, target: { ...e.target, value: val } }
      onChange(event)
    }
  }

  return (
    <Wrapper>
      <Label>
        <LabelLine />
        <LabelName>{label || '라벨'}</LabelName>
      </Label>
      <InputWrapper>
        <Input
          type="text"
          placeholder={placeholder || '이름을 입력하세요'}
          value={inputValue}
          onChange={handleChange}
        />
        {unit && (
          <InputUnit>
            <Unit>{unit}</Unit>
          </InputUnit>
        )}
        <InputLine />
      </InputWrapper>
    </Wrapper>
  )
}

export default LabelInput
